module.exports = __webpack_public_path__ + "static/10400556_21577812223_4134_n-be0ed47a60ea451ce497c029153513dc.jpg";